(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6655],{

/***/ 70770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ SectionTitle; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var SectionTitle = function SectionTitle(_ref) {
  var titleText = _ref.titleText,
      subTitleText = _ref.subTitleText,
      enTitleText = _ref.enTitleText,
      color = _ref.color,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'h3' : _ref$as;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(SectionTitleDiv, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TitleText, {
      color: color,
      as: as,
      children: titleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(EnTitleText, {
      color: color,
      as: as,
      children: enTitleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SubTitleText, {
      color: color,
      children: subTitleText
    })]
  });
};
var SectionTitleDiv = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SectionTitle__SectionTitleDiv",
  componentId: "sc-17562y0-0"
})(["text-align:center;"]);
var TitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "SectionTitle__TitleText",
  componentId: "sc-17562y0-1"
})(["font-weight:bold;font-size:42px;line-height:50px;margin-bottom:6px;color:", ";font-family:", ";@media screen and (max-width:1047px){display:none;}"], function (_ref2) {
  var color = _ref2.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue) : "white";
}, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.fontEn */ .r.fontEn);
var SubTitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "SectionTitle__SubTitleText",
  componentId: "sc-17562y0-2"
})(["font-size:18px;line-height:26px;color:", ";@media screen and (max-width:1047px){font-size:23px;line-height:1.2;font-weight:700;}"], function (_ref3) {
  var color = _ref3.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.overlay */ .r.colors.overlay) : "white";
});
var EnTitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "SectionTitle__EnTitleText",
  componentId: "sc-17562y0-3"
})(["@media screen and (min-width:1048px){font-weight:bold;font-size:42px;line-height:50px;margin-bottom:6px;color:", ";font-family:", ";}@media screen and (max-width:1047px){font-size:23px;line-height:1.2;font-weight:700;}"], function (_ref4) {
  var color = _ref4.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue) : "white";
}, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.fontEn */ .r.fontEn);

/***/ }),

/***/ 22978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Head; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var Head = function Head(_ref) {
  var _ogp$image, _ogp$type;

  var title = _ref.title,
      _ref$hasTitleSuffix = _ref.hasTitleSuffix,
      hasTitleSuffix = _ref$hasTitleSuffix === void 0 ? true : _ref$hasTitleSuffix,
      description = _ref.description,
      noindex = _ref.noindex,
      ogp = _ref.ogp;
  var ogpImage = (_ogp$image = ogp === null || ogp === void 0 ? void 0 : ogp.image) !== null && _ogp$image !== void 0 ? _ogp$image : {
    src: 'https://trial-holdings.inc/images/ogp.png',
    width: 1200,
    height: 630
  };
  var titleText = hasTitleSuffix ? "".concat(title, " | \u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9") : title;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
      children: titleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "description",
      content: description
    }), noindex && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "robots",
      content: "noindex, nofollow"
    }), ogp && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:type",
        content: (_ogp$type = ogp.type) !== null && _ogp$type !== void 0 ? _ogp$type : 'website'
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:url",
        content: "https://trial-holdings.inc/".concat(ogp.url)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:title",
        content: ogp.title || titleText
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:description",
        content: description
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image",
        content: ogpImage.src
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:width",
        content: "".concat(ogpImage.width)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:height",
        content: "".concat(ogpImage.height)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:site_name",
        content: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:locale",
        content: "ja_JP"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "icon",
      href: "/images/favicon.ico"
    })]
  });
};

/***/ }),

/***/ 99071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ Index; }
/* harmony export */ });
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27812);
/* harmony import */ var react_scroll__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66261);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);





var Index = function Index(_ref) {
  var links = _ref.links,
      listType = _ref.listType,
      columnGap = _ref.columnGap;

  // ナンバリングのスタート値を計算する
  var setStartValue = function setStartValue(index) {
    var count = 0;
    if (index === 0) return count;

    (0,_workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(Array(index)).map(function (_, i) {
      return count += links[i].length;
    });

    return count;
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Wrapper, {
    columnGap: columnGap,
    children: links.map(function (arr, index) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(List, {
        startValue: setStartValue(index),
        listType: listType,
        as: listType === 'disc' ? 'ul' : '',
        children: arr.map(function (_ref2) {
          var name = _ref2.name,
              anchor = _ref2.anchor;
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("li", {
            "data-list-type": listType,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_scroll__WEBPACK_IMPORTED_MODULE_0__/* .Link */ .rU, {
              to: anchor,
              smooth: true,
              offset: -105,
              children: name
            })
          }, name);
        })
      }, "".concat(arr.toString()).concat(index));
    })
  });
};
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Index__Wrapper",
  componentId: "sc-12faqix-0"
})(["border:1px solid #707070;padding:30px 33px 25px;display:flex;column-gap:", "px;@media screen and (max-width:1047px){flex-direction:column;padding:30px 20px 27px;}"], function (_ref3) {
  var columnGap = _ref3.columnGap;
  return columnGap;
});
var ListStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(["color:", ";counter-increment:number;"], _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.trialBlue */ .r.colors.trialBlue);
var List = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].ol.withConfig */ .ZP.ol.withConfig({
  displayName: "Index__List",
  componentId: "sc-12faqix-1"
})(["letter-spacing:0.32px;counter-reset:", ";li{line-height:26px;letter-spacing:0.3px;&:hover{opacity:0.7;cursor:pointer;}&[data-list-type='number']::before{", ";content:counter(number) '. ';}&[data-list-type='roman']::before{", ";content:counter(number,upper-roman) '. ';}&[data-list-type='article']::before{", ";content:'\u7B2C' counter(number) '\u6761';}&[data-list-type='disc']::before{content:'';width:6px;height:6px;border-radius:50%;background-color:", ";display:inline-block;margin-right:0.5em;transform:translateY(-50%);}}a{color:", ";}@media screen and (max-width:1047px){li{font-size:15px;}}"], function (_ref4) {
  var startValue = _ref4.startValue,
      listType = _ref4.listType;
  return listType !== 'disc' ? "number ".concat(startValue) : '';
}, ListStyle, ListStyle, ListStyle, _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.trialBlue */ .r.colors.trialBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.trialBlue */ .r.colors.trialBlue);

/***/ }),

/***/ 68339:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$V": function() { return /* binding */ SectionDiv; },
/* harmony export */   "CK": function() { return /* binding */ StyledList; },
/* harmony export */   "JP": function() { return /* binding */ GridTable2; },
/* harmony export */   "Jn": function() { return /* binding */ GridRow; },
/* harmony export */   "R1": function() { return /* binding */ GridTable; },
/* harmony export */   "U5": function() { return /* binding */ SummaryDiv; },
/* harmony export */   "ZB": function() { return /* binding */ ZenkakuSpace; },
/* harmony export */   "_b": function() { return /* binding */ StyledListInGridRow; },
/* harmony export */   "eX": function() { return /* binding */ StyledH3; },
/* harmony export */   "oH": function() { return /* binding */ StyledListItem; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);


var StyledLink = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["color:", ";text-decoration:underline;"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue);
var SummaryDiv = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TextStyle__SummaryDiv",
  componentId: "sc-rdu7qb-0"
})(["text-align:left;font-size:16px;color:", ";font-weight:400;line-height:26px;letter-spacing:0.32px;a{", "}@media screen and (max-width:1047px){font-size:15px;line-height:25px;letter-spacing:0.3px;}"], function (_ref) {
  var color = _ref.color;
  return color === undefined ? _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.textTitle */ .r.colors.textTitle : color;
}, StyledLink);
var H3Style = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["font-size:22px;color:", ";font-weight:bold;line-height:30px;letter-spacing:0.88px;@media screen and (max-width:1047px){font-size:15px;letter-spacing:0.6px;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue);
var StyledH3 = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "TextStyle__StyledH3",
  componentId: "sc-rdu7qb-1"
})(["", ""], H3Style);
var SectionDiv = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TextStyle__SectionDiv",
  componentId: "sc-rdu7qb-2"
})(["width:100%;display:flex;flex-direction:column;row-gap:24px;text-align:left;font-size:16px;color:", ";font-weight:400;line-height:26px;letter-spacing:0.32px;h3{", "}ul{li{max-width:", ";}}ol{padding-left:25px;list-style-type:decimal;}li{span{display:block;font-weight:bold;}}p{span{font-weight:bold;}}a{", "}@media screen and (max-width:1047px){row-gap:30px;font-size:14px;line-height:24px;letter-spacing:0.28px;ul{li{width:100%;}}}"], function (_ref2) {
  var color = _ref2.color;
  return color === undefined ? _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.textTitle */ .r.colors.textTitle : color;
}, H3Style, function (_ref3) {
  var liWidth = _ref3.liWidth;
  return liWidth === undefined ? '100%' : "".concat(liWidth, "px");
}, StyledLink);
var GridTable = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TextStyle__GridTable",
  componentId: "sc-rdu7qb-3"
})(["width:100%;display:grid;grid-template-columns:25% 25% 25% 25%;grid-template-rows:auto;border-top:1px solid #707070;border-left:1px solid #707070;@media screen and (max-width:1047px){grid-template-columns:50% 50%;}"]); // カラムが６つのテーブル、テーブル内の文章が単語関係なく改行

var GridTable2 = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TextStyle__GridTable2",
  componentId: "sc-rdu7qb-4"
})(["width:100%;display:grid;grid-template-columns:repeat(6,16.6666667%);grid-template-rows:auto;border-top:1px solid #707070;border-left:1px solid #707070;word-break:break-all;"]);
var GridRow = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TextStyle__GridRow",
  componentId: "sc-rdu7qb-5"
})(["width:100%;display:contents;border-bottom:1px solid #707070;div{border-bottom:1px solid #707070;border-right:1px solid #707070;padding:20px 20px;}@media screen and (max-width:1047px){margin:0px 20px;div{padding:16px 20px 18px;}}"]);
var StyledList = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
  displayName: "TextStyle__StyledList",
  componentId: "sc-rdu7qb-6"
})(["counter-reset:number ", ";max-width:", ";margin-left:", ";@media screen and (max-width:1047px){width:100%;margin-left:0;padding-left:", ";}"], function (_ref4) {
  var startValue = _ref4.startValue;
  return startValue === undefined ? '' : startValue;
}, function (_ref5) {
  var liWidth = _ref5.liWidth;
  return liWidth === undefined ? '100%' : "".concat(liWidth, "px");
}, function (_ref6) {
  var marginLeft = _ref6.marginLeft;
  return marginLeft === undefined ? '0' : "".concat(marginLeft, "em");
}, function (_ref7) {
  var paddingLeft = _ref7.paddingLeft;
  return paddingLeft === undefined ? '0' : "".concat(paddingLeft, "em");
});
var StyledListInGridRow = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(StyledList).withConfig({
  displayName: "TextStyle__StyledListInGridRow",
  componentId: "sc-rdu7qb-7"
})(["padding-left:0.8em;"]);
var Article = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["padding-left:1.5em;text-indent:-2.5em;::before{counter-increment:number;content:'\uFF08' counter(number) '\uFF09';}"]);
var BoldArticle = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["padding-left:1.5em;text-indent:-2.5em;font-weight:bold;p{text-indent:0em;font-weight:400;}::before{counter-increment:number;content:'\uFF08' counter(number) '\uFF09';}"]);
var Disc = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["text-indent:-1em;::before{counter-increment:number;content:'\u30FB';}"]);
var Comment = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["padding-left:0.5em;text-indent:-3.5em;::before{counter-increment:number;content:'\uFF08\u6CE8' counter(number) '\uFF09';}@media screen and (max-width:1047px){text-indent:-0.5em;}"]);
var Number = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["padding-left:0.5em;text-indent:-1.5em;::before{counter-increment:number;content:counter(number) '. ';}"]);
var StyledListItem = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].li.withConfig */ .ZP.li.withConfig({
  displayName: "TextStyle__StyledListItem",
  componentId: "sc-rdu7qb-8"
})(["font-weight:400;", " ", ";", ";"], function (_ref8) {
  var listType = _ref8.listType;

  switch (listType) {
    case 'article':
      return Article;

    case 'disc':
      return Disc;

    case 'comment':
      return Comment;

    case 'boldArticle':
      return BoldArticle;

    case 'number':
      return Number;

    case undefined:
      break;
  }
}, function (_ref9) {
  var paddingLeft = _ref9.paddingLeft;
  return paddingLeft && "padding-left:".concat(paddingLeft, "em");
}, function (_ref10) {
  var textIndent = _ref10.textIndent;
  return textIndent && "text-indent:".concat(textIndent, "em");
});
var ZenkakuSpace = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "TextStyle__ZenkakuSpace",
  componentId: "sc-rdu7qb-9"
})(["padding-left:", ";"], function (_ref11) {
  var space = _ref11.space;
  return space === undefined ? '1em' : "".concat(space, "em");
});

/***/ }),

/***/ 57536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ SecurityPage; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/components/pages/Legal/TextStyle.tsx
var TextStyle = __webpack_require__(68339);
// EXTERNAL MODULE: ./src/components/elements/LinkText/index.tsx
var LinkText = __webpack_require__(41705);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/pages/Legal/SecurityPolicy/SecurityItems.tsx





var scItems = [{
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "\u7B2C1\u6761\uFF08\u60C5\u5831\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u7BA1\u7406\u4F53\u5236\u306E\u69CB\u7BC9\uFF09"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u304C\u4FDD\u6709\u3059\u308B\u5168\u3066\u306E\u60C5\u5831\u8CC7\u7523\u306E\u4FDD\u8B77\u306B\u52AA\u3081\u3001\u60C5\u5831\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u306B\u95A2\u3059\u308B\u6CD5\u4EE4\u305D\u306E\u4ED6\u306E\u898F\u7BC4\u3092\u9075\u5B88\u3059\u308B\u3053\u3068\u306B\u3088\u308A\u3001\u793E\u4F1A\u304B\u3089\u306E\u4FE1\u983C\u3092\u5E38\u306B\u5F97\u3089\u308C\u308B\u3088\u3046\u3001\u53B3\u91CD\u306A\u60C5\u5831\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u7BA1\u7406\u4F53\u5236\u3092\u69CB\u7BC9\u3057\u3066\u3044\u304D\u307E\u3059\u3002"
    })]
  }),
  id: 'security1'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "\u7B2C2\u6761\uFF08\u300C\u60C5\u5831\u7D71\u62EC\u5F79\u54E1\u300D\u306E\u914D\u7F6E\uFF09"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "\u60C5\u5831\u7D71\u62EC\u5F79\u54E1\u3092\u8A2D\u7F6E\u3059\u308B\u3068\u3068\u3082\u306B\u3001\u60C5\u5831\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u59D4\u54E1\u4F1A\u3092\u7D44\u7E54\u3057\u307E\u3059\u3002 \u3053\u308C\u306B\u3088\u308A\u5168\u793E\u306B\u308F\u305F\u308B\u60C5\u5831\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u306E\u72B6\u6CC1\u3092\u6B63\u78BA\u306B\u628A\u63E1\u3057\u3001\u5FC5\u8981\u306A\u5BFE\u7B56\u3092\u8FC5\u901F\u306B\u5B9F\u65BD\u3067\u304D\u308B\u3088\u3046\u7A4D\u6975\u7684\u306A\u6D3B\u52D5\u3092\u884C\u3044\u307E\u3059\u3002"
    })]
  }),
  id: 'security2'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "\u7B2C3\u6761\uFF08\u60C5\u5831\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u306B\u95A2\u3059\u308B\u5185\u90E8\u898F\u7A0B\u306E\u6574\u5099\uFF09"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "\u60C5\u5831\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u30DD\u30EA\u30B7\u30FC\u306B\u57FA\u3065\u3044\u305F\u5185\u90E8\u898F\u7A0B\u3092\u6574\u5099\u3057\u3001\u500B\u4EBA\u60C5\u5831\u3060\u3051\u3067\u306F\u306A\u304F\u3001\u60C5\u5831\u8CC7\u7523\u5168\u822C\u306E\u53D6\u308A\u6271\u3044\u306B\u3064\u3044\u3066\u660E\u78BA\u306A\u65B9\u91DD\u3092\u793A\u3059\u3068\u3068\u3082\u306B\u3001\u60C5\u5831\u6F0F\u6D29\u7B49\u306E\u60C5\u5831\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u4E8B\u6545\u306B\u5BFE\u3057\u3066\u306F\u3001\u53B3\u3057\u3044\u614B\u5EA6\u3067\u81E8\u3080\u3053\u3068\u3092\u793E\u5185\u5916\u306B\u5468\u77E5\u5FB9\u5E95\u3057\u307E\u3059\u3002"
    })]
  }),
  id: 'security3'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "\u7B2C4\u6761\uFF08\u696D\u52D9\u59D4\u8A17\u5148\u306E\u7BA1\u7406\u4F53\u5236\u5F37\u5316\uFF09"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "\u696D\u52D9\u59D4\u8A17\u5951\u7D04\u3092\u7DE0\u7D50\u3059\u308B\u969B\u306B\u306F\u3001\u696D\u52D9\u59D4\u8A17\u5148\u3068\u3057\u3066\u306E\u9069\u683C\u6027\u3092\u5341\u5206\u306B\u8ABF\u67FB\u3057\u305F\u4E0A\u3067\u3001\u60C5\u5831\u8CC7\u7523\u306E \u4FDD\u8B77\u53CA\u3073\u79D8\u5BC6\u3092\u4FDD\u6301\u3055\u305B\u308B\u305F\u3081\u306B\u5FC5\u8981\u306A\u5951\u7D04\u3092\u7DE0\u7D50\u3059\u308B\u3068\u3068\u3082\u306B\u3001\u9069\u5207\u306A\u76E3\u7763\u3092\u884C\u3044\u307E\u3059\u3002"
    })]
  }),
  id: 'security4'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "\u7B2C5\u6761\uFF08\u6559\u80B2\u30FB\u7814\u4FEE\u306E\u5B9F\u65BD\uFF09"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "\u5F93\u696D\u54E1\u306B\u60C5\u5831\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u6559\u80B2\u30FB\u7814\u4FEE\u3092\u5FB9\u5E95\u3057\u3001\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306E\u60C5\u5831\u8CC7\u7523\u306B\u95A2\u308F\u308B\u5168\u54E1\u304C\u3001\u60C5\u5831\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u306E\u91CD\u8981\u6027\u3092\u8A8D\u8B58\u3057\u305F\u4E0A\u3067\u696D\u52D9\u3092\u9042\u884C\u3067\u304D\u308B\u3088\u3046\u306B\u3057\u307E\u3059\u3002"
    })]
  }),
  id: 'security5'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "\u7B2C6\u6761\uFF08\u60C5\u5831\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u306E\u7D99\u7D9A\u7684\u306A\u6539\u5584\uFF09"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306F\u60C5\u5831\u8CC7\u7523\u306E\u5229\u7528\u76EE\u7684\u30FB\u91CD\u8981\u5EA6\u306B\u5FDC\u3058\u305F\u9069\u5207\u306A\u7BA1\u7406\u4F53\u5236\u3092\u5B9F\u73FE\u3059\u308B\u305F\u3081\u3001\u60C5\u5831\u8CC7\u7523\u306B\u5BFE\u3059\u308B\u8105\u5A01\u3092\u7279\u5B9A\u3057\u3001\u7D99\u7D9A\u7684\u306B\u30EA\u30B9\u30AF\u5206\u6790\u30FB\u8A55\u4FA1\u3092\u884C\u3044\u307E\u3059\u3002\u30EA\u30B9\u30AF\u8A55\u4FA1\u306E\u7D50\u679C\u306B\u57FA\u3065\u3044\u3066\u3001\u7279\u5B9A\u3055\u308C\u305F\u8105\u5A01\u306B\u5BFE\u3059\u308B\u5408\u7406\u7684\u306A\u60C5\u5831\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u5BFE\u7B56\u3092\u5B9F\u65BD\u3057\u3001\u60C5\u5831\u8CC7\u7523\u306E\u5B89\u5168\u7BA1\u7406\u306B\u53D6\u308A\u7D44\u307F\u307E\u3059\u3002"
    })]
  }),
  id: 'security6'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "\u7B2C7\u6761\uFF08\u305D\u306E\u4ED6\uFF09"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
      children: ["\u500B\u4EBA\u60C5\u5831\u306B\u3064\u3044\u3066\u306F\u3001\u5225\u63B2\u306E", /*#__PURE__*/(0,jsx_runtime.jsx)(LinkText/* LinkText */.u, {
        path: "/legal/privacy-policy/",
        text: "\u300C\u500B\u4EBA\u60C5\u5831\u4FDD\u8B77\u65B9\u91DD\u300D"
      }), "\u306B\u6E96\u3058\u3066\u7BA1\u7406\u3057\u307E\u3059\u3002"]
    })]
  }),
  id: 'security7'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
      children: ["\u5236\u5B9A\u65E5", /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* ZenkakuSpace */.ZB, {}), "2018\u5E7410\u67083\u65E5", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u6700\u7D42\u6539\u5B9A\u65E5", /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* ZenkakuSpace */.ZB, {}), "2022\u5E7411\u670822\u65E5"]
    })
  }),
  id: 'signInfo'
}];
var scLinks = [[{
  name: '（情報セキュリティ管理体制の構築）',
  anchor: 'security1'
}, {
  name: '（「情報統括役員」の配置）',
  anchor: 'security2'
}, {
  name: '（情報セキュリティに関する内部規程の整備）',
  anchor: 'security3'
}], [{
  name: '（業務委託先の管理体制強化）',
  anchor: 'security4'
}, {
  name: '（教育・研修の実施）',
  anchor: 'security5'
}, {
  name: '（情報セキュリティの継続的な改善）',
  anchor: 'security6'
}], [{
  name: '（その他）',
  anchor: 'security7'
}]];
// EXTERNAL MODULE: ./src/components/elements/SectionTitle/index.tsx
var SectionTitle = __webpack_require__(70770);
// EXTERNAL MODULE: ./src/components/elements/Spacer/index.tsx
var Spacer = __webpack_require__(1253);
// EXTERNAL MODULE: ./src/components/layout.tsx + 7 modules
var layout = __webpack_require__(55548);
// EXTERNAL MODULE: ./src/components/layouts/Head/index.tsx
var Head = __webpack_require__(22978);
// EXTERNAL MODULE: ./src/components/layouts/Legal/Index/index.tsx
var Index = __webpack_require__(99071);
;// CONCATENATED MODULE: ./src/components/pages/Legal/SecurityPolicy/index.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













var sectionTitle = {
  titleText: 'Information Security Policy',
  subTitleText: '情報セキュリティポリシー'
};

var tSummary = /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
  children: ["\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\uFF08\u682A\u5F0F\u4F1A\u793E\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9\u53CA\u3073\u305D\u306E\u30B0\u30EB\u30FC\u30D7\u4F1A\u793E\uFF09\u306F\u3001\u60C5\u5831\u6F0F\u6D29\u30EA\u30B9\u30AF\u306B\u5BFE\u3057\u3001\u53B3\u91CD\u306A\u7BA1\u7406\u4F53\u5236\u3092\u69CB\u7BC9\u3059\u308B\u3053\u3068\u306B\u3088\u308A\u3001\u304A\u5BA2\u69D8\u3092\u306F\u3058\u3081\u793E\u4F1A\u304B\u3089\u306E\u4FE1\u983C\u3092\u5E38\u306B\u5F97\u3089\u308C\u308B\u3088\u3046\u3001\u300C\u60C5\u5831\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u30DD\u30EA\u30B7\u30FC\u300D\u3092\u7B56\u5B9A\u3057\u307E\u3057\u305F\u3002", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u4ECA\u5F8C\u306F\u3053\u306E\u300C\u60C5\u5831\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u30DD\u30EA\u30B7\u30FC\u300D\u3092\u9075\u5B88\u3057\u3001\u3055\u307E\u3056\u307E\u306A\u8105\u5A01\u304B\u3089\u60C5\u5831\u8CC7\u7523\u3092\u4FDD\u8B77\u3057\u3001\u304B\u3064\u9069\u6B63\u306B\u53D6\u308A\u6271\u3046\u3053\u3068\u306B\u3088\u308A\u3001\u60C5\u5831\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u306E\u7DAD\u6301\u306B\u52AA\u3081\u3066\u307E\u3044\u308A\u307E\u3059\u3002"]
});

var SecurityPage = function SecurityPage() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Head/* Head */.F, {
      title: "\u60C5\u5831\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u30DD\u30EA\u30B7\u30FC",
      description: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9\u306E\u60C5\u5831\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u30DD\u30EA\u30B7\u30FC\u3092\u63B2\u8F09\u3057\u3066\u3044\u307E\u3059\u3002",
      ogp: {
        type: 'article',
        url: 'legal/security-policy/'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SecurityContainer, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CompleteTitle, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
          color: "normal",
          titleText: sectionTitle.titleText,
          subTitleText: sectionTitle.subTitleText
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          pc: 70,
          sp: 60
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* SummaryDiv */.U5, {
        children: tSummary
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          pc: 70,
          sp: 35
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Index/* Index */.g, {
        columnGap: 70,
        listType: "article",
        links: scLinks
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          pc: 70,
          sp: 40
        }
      }), scItems.map(function (_ref, index) {
        var children = _ref.children,
            id = _ref.id;
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* SectionDiv */.$V, {
            id: id,
            children: children
          }), index < scItems.length - 1 && /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
            h: {
              pc: 70,
              sp: 39
            }
          })]
        }, "".concat(id).concat(index));
      })]
    })]
  });
};

SecurityPage.getLayout = function (page) {
  var pageTitle = {
    title: 'Legal',
    subTitle: '法務'
  };
  var breadCrumbs = [{
    name: 'ホーム',
    path: '/'
  }, {
    name: '法務',
    path: '/legal/'
  }, {
    name: '情報セキュリティポリシー',
    path: ''
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsx)(layout/* TitleLayout */.$0, _objectSpread(_objectSpread({}, pageTitle), {}, {
    breadCrumbs: breadCrumbs,
    isRequiredBackground: false,
    children: page
  }));
};

var SecurityContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SecurityPolicy__SecurityContainer",
  componentId: "sc-yo52rh-0"
})(["width:1040px;padding-top:62px;padding-bottom:130px;margin:0 auto;@media screen and (max-width:1047px){width:100%;padding:40px 20px 70px;}"]);
var CompleteTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SecurityPolicy__CompleteTitle",
  componentId: "sc-yo52rh-1"
})(["width:100%;margin:0 auto;@media screen and (max-width:1047px){max-width:200px;}"]);
;// CONCATENATED MODULE: ./src/pages/legal/security-policy.tsx


/***/ }),

/***/ 35408:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/security-policy",
      function () {
        return __webpack_require__(57536);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,3874,2768,8517,5548,9774,2888,179], function() { return __webpack_exec__(35408); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);